import pick from 'lodash.pick';
import Alert from 'react-s-alert';
import { SubmissionError } from "redux-form";
import C from '../../../constants';
import rStore from "../../../store";
import { hideModal } from '../../../store/actions/display';
import { setUser } from '../../../store/actions/user';
import PolyUtil from '../../../util/PolyUtil';
import RuntimeTools from "../../../util/RuntimeTools";
import { logoutUser } from "../../authentication/actions/authentication";
import { fetchStatus } from "../../listings/actions/listings";
import { fetchTenantBillingInfo } from "./billing";
import { fetchInvitations, fetchListingPreferences, fetchRecommendedListings, fetchRoommateGroup } from './roommates';


export const setTenant = (tenant) => ({
    type: C.SET_TENANT,
    payload: tenant
});

export const addToInterestList = (property) => ({
    type: C.ADD_INTEREST_LIST,
    payload: property
});

export const removeFromInterestList = (property) => ({
    type: C.REMOVE_INTEREST_LIST,
    payload: property
});

export const setInterestList = (interest_list) => ({
    type: C.SET_INTEREST_LIST,
    payload: interest_list
});

export const setTenantIdmaStatus = (status) => ({
    type: C.SET_IDMA_STATUS,
    payload: status
});

export const setTenantSkipGuarantor = (skip) => ({
    type: C.SET_TENANT_SKIP_GUARANTOR,
    payload: skip
});

export const setTenantPrefRent = (values) => ({
    type: C.SET_TENANT_LISTING_PREF_RENT,
    payload: {
        min_rent: values[0],
        max_rent: values[1]
    }
});

export const setTenantPrefBed = (values) => ({
    type: C.SET_TENANT_LISTING_PREF_BED,
    payload: {
        min_bedrooms: values[0],
        max_bedrooms: values[1]
    }
});

export const setTenantPrefBath = (values) => ({
    type: C.SET_TENANT_LISTING_PREF_BATH,
    payload: {
        min_bathrooms: values[0],
        max_bathrooms: values[1]
    }
});

export const setMinLeaseMonth = (value) => ({
    type: C.SET_TENANT_MIN_LEASE_START,
    payload: parseInt(value, 10)
});

export const setMaxLeaseMonth = (value) => ({
    type: C.SET_TENANT_MAX_LEASE_START,
    payload: parseInt(value, 10)
});

export const setCoordinateGroup = () => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/rome/',
        {
            method: 'POST',
            body: JSON.stringify({
                rome_decision: 'coordinate_group'
            })
        }
    ).then(() => {
        return dispatch(fetchRoommateGroup());
    }).catch((error) => {
        console.log('Error: ', error);
    });
};

export const fetchTenantIdmaStatus = () => dispatch => {
    return PolyUtil.fetchWrapper('/api/credit/idma/check-status/',
        {method: 'GET'}
    ).then((data) => {
        return dispatch(setTenantIdmaStatus(data.verification_status));
    }).catch((error) => {
        console.log("Error: ", error);
    });
};

export const fetchTenantInterestList = () => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/', {
        method: 'GET'
    }).then((data) => {
        return dispatch(setInterestList(data.interest_list));
    }).catch((error) => {
        console.log("Error", error);
    });
};

export const fetchTenant = () => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/', {
        method: 'GET'
    }).then((data) => {
        const details = data.intercom_details;
        RuntimeTools.updateIntercomDetails(details);
        RuntimeTools.updateFullstoryDetails(details);
        RuntimeTools.setRavenContext(data.email, 'tenant');

        dispatch(setUser(
            Object.assign(
                {}, {user_type: 'tenant'}, pick(data, [
                    'first_name', 'last_name', 'email', 'phone'
                ])
            )
        ));

        return dispatch(setTenant(
            Object.assign(
                pick(data, [
                    'application',
                    'interest_list',
                    'skip_guarantor',
                    'phone_verified',
                    'send_email_notifications',
                    'send_sms_notifications'
                ])
            )
        ));
    }).catch((error) => {
        console.log("Error: ", error);

        if (error.detail ==='Invalid token.') {
            return dispatch(logoutUser());
        }

    });
};

export const fetchAllTenant = () => dispatch => {
    return dispatch(fetchTenant()).then(() => {
        return dispatch(fetchRoommateGroup());
    }).then(() => {
        return dispatch(fetchInvitations());
    }).then(() => {
        return dispatch(fetchRecommendedListings());
    }).then(() => {
        return dispatch(fetchListingPreferences());
    }).then(() => {
        return dispatch(fetchTenantBillingInfo());
    }).then(() => {
        return dispatch(fetchTenantIdmaStatus());
    }).catch((error) => {
        console.log("Error: Invalid user token, logging out...");
        if (error.non_field_errors) {
            error._error = error.non_field_errors;
            delete error.non_field_errors;
        }
    });

};

export const handleSetSkipGuarantor = (skip) => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/application/guarantor/',
        {
            method: 'PUT',
            body: JSON.stringify({skip_guarantor: skip})
        }
    ).then(() => {
        return dispatch(setTenantSkipGuarantor(skip));
    }).catch((error) => {
        console.log("Error:", error);
    });
};

export const handleAddToInterestList = (property) => dispatch => {
    return PolyUtil.fetchNoResponse('/api/tenant/interest-list/add/', {
        method: "POST",
        body: JSON.stringify({
            property_id: property.id
        })
    }).then(() => {
        return dispatch(fetchTenantInterestList());
    }).catch((error) => {
        console.log("Error: ", error);
    });
};

export const handleRemoveFromInterestList = (property) => dispatch => {
    return PolyUtil.fetchNoResponse('/api/tenant/interest-list/remove/', {
        method: "POST",
        body: JSON.stringify({
            property_id: property.id
        })
    }).then(() => {
        return dispatch(removeFromInterestList(property));
    }).catch((error) => {
        console.log("Error: ", error);
    });
};

export const handleApply = (apply_key) => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/listings/' + apply_key + '/application/apply/',
        {method: 'POST'}
    ).then(() => {
        return dispatch(fetchRoommateGroup());
    }).then(() => {
        return dispatch(fetchStatus(apply_key));
    }).then(() => {
        return dispatch(hideModal('confirm_application_change_modal'));
    }).then(() => {
        Alert.success("Applied to property!");
    }).catch((error) => {
        Alert.error(error.error_message);
        console.log("Error: ", error);
        return dispatch(hideModal('confirm_application_change_modal'));
    });
};

export const handleWithdraw = (apply_key) => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/listings/' + apply_key + '/application/withdraw/',
        {method: 'POST'}
    ).then(() => {
        return dispatch(fetchRoommateGroup());
    }).then(() => {
        return dispatch(fetchStatus(apply_key));
    }).then(() => {
        return dispatch(hideModal('confirm_application_change_modal'));
    }).then(() => {
        Alert.success("Withdrew application from this listing!");
    }).catch((error) => {
        console.log("Error: ", error);
        return dispatch(hideModal('confirm_application_change_modal'));
    });
};

export const handleSetPhoneNumber = (phone, noNotification) => dispatch => {
    return PolyUtil.fetchWrapper('/api/tenant/',
        {
            method: 'PATCH',
            body: JSON.stringify(phone)
        }
    ).then(() => {
        !noNotification && Alert.success("Successfully added your phone number!");
        return dispatch(fetchTenant());
    }).catch((error) => {
        console.log("Error: ", error);
        if (error.non_field_errors) {
            error._error = error.non_field_errors;
            delete error.non_field_errors;
        }
        throw new SubmissionError(error);
    });
};

export const handleSetNotifications = (medium, value) => dispatch => {
    const body = medium === 'email' ? {send_email_notifications: value} : {send_sms_notifications: value};

    return PolyUtil.fetchWrapper('/api/tenant/',
        {
            method: 'PATCH',
            body: JSON.stringify(body)
        }
    ).then((data) => {
        return dispatch(setTenant(data));
    }).then(() => {
        Alert.success("Updated notification settings!");
    }).catch((error) => {
        console.log("Error: ", error);
    });
};

export const handleVerifyPhone = (phone) => dispatch => {
    if (!rStore.getState().tenant.phone_verified) {
        return PolyUtil.fetchWrapper('/api/verify/phone/' + phone.code + '/',
            {method: 'POST'}
        ).then(() => {
            return dispatch(fetchTenant());
        }).then(() => {
            Alert.success("Successfully verified your phone number!");
        }).catch((error) => {
            console.log("Error: ", error);
            if (error.non_field_errors) {
                error._error = error.non_field_errors;
                delete error.non_field_errors;
            }

            error.code = [error.error_message];
            throw new SubmissionError(error);
        });
    }
};

export const handleResendCode = () => dispatch => {
    return PolyUtil.fetchNoResponse('/api/verify/phone/',
        {method: 'POST'}
    ).then(() => {
        Alert.success("Resent SMS verification code!");
    }).catch((error) => {
        console.log("Error: ", error);
    });
};



// WEBPACK FOOTER //
// ./src/containers/tenant/actions/tenant.js